import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../../actions'
import { Container, Button, TableRow, TableHeaderCell, TableHeader, TableCell, TableBody, Table, Grid, GridColumn, Loader, Icon } from 'semantic-ui-react'

const Games = ({ onChangeItem }) => {
    const dispatch = useDispatch()
    const games = useSelector(state => state.games)

    useEffect(() => {
        dispatch(actions.fetchGames('admin'))
    }, [dispatch])
    
    const renderTableRows = () => {
        var rows = []
        for (const [i, game] of (games || []).entries()) {
            const emoji = game.supplier === 'monkey' ? '🐵 ' : game.supplier === 'elephant' ? '🐘 ' : ''
            rows.push(
                <TableRow key={i} style={{ cursor: 'pointer' }} onClick={() => handleEditClicked(game)}>
                    <TableCell>{emoji}{game.name}</TableCell>
                    <TableCell textAlign='center'>{game.hasPackages ? <Icon color='green' name='checkmark' size='large' /> : '-'}</TableCell>
                    <TableCell textAlign='center'>{game.isHidden ? <Icon color='green' name='checkmark' size='large' /> : '-'}</TableCell>
                    <TableCell textAlign='center'>{game.isOutOfStock ? <Icon color='green' name='checkmark' size='large' /> : '-'}</TableCell>
                    <TableCell textAlign='center'>{game.priority}</TableCell>
                </TableRow>
            )
        }
        return rows
    }

    const renderTable = () => {
        if (games == null) return <Loader active size="large" inverted>Loading</Loader>
        return <Table size={window.innerWidth < 768 ? 'small' : null} unstackable inverted style={{ overflowX: 'auto', display: 'block', whiteSpace: 'nowrap' }}>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell>Name</TableHeaderCell>
                        <TableHeaderCell width='2' textAlign='center'>Has Packages</TableHeaderCell>
                        <TableHeaderCell width='2' textAlign='center'>Is Hidden</TableHeaderCell>
                        <TableHeaderCell width='2' textAlign='center'>Is Out of Stock</TableHeaderCell>
                        <TableHeaderCell width='1' textAlign='center'>Priority</TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {renderTableRows()}
                </TableBody>
            </Table>
    }

    const handleEditClicked = (game) => {
        onChangeItem('edit-game', game)
    }
    return (
        <Container inverted style={{ background: '#1b1c1d', minHeight: '100vh' }}>
            <Grid style={{ marginTop: 10, marginBottom: 15 }}>
                <GridColumn floated='left' width={5}><h1 style={{ color: 'white' }}>Games</h1></GridColumn>
                <GridColumn floated='right' width={5}>
                    <Button size={window.innerWidth <= 760 ? 'mini' : null} color="teal" inverted floated='right' onClick={() => onChangeItem('new-game')}><Icon name='add'/>Create New Game</Button>
                </GridColumn>
            </Grid>
            {renderTable()}
        </Container>
    )
}

export default Games